const BASE_URL = "https://liveqr.co/api"; 

export default BASE_URL;
